(() => {
  const host = document.getElementById("razorpay-affordability-widget");
  if (!host) return;

  const theme = {
    "--theme-color": "#F06418",
    "--theme-color-border": "#F0641899",
    "--theme-color-low-opacity": "#F0641812",
    "--heading-color": "#173247",
    "--heading-size": "14px",
    "--content-color": "#64748B",
    "--content-size": "12px",
    "--link-color": "#C94F10",
    "--link-border-color": "#C94F1099",
    "--link-size": "12px",
    "--footer-color": "#64748B",
    "--footer-size": "11px",
    "--widget-content-background": "#FFFFFF"
  };

  const css = [
    "main { width: 100% !important; max-width: 640px !important; margin: 0 auto !important; }",
    "[data-testid=\"wrapper-affordability\"] { box-sizing: border-box !important; width: 100% !important; max-width: 100% !important; background: #FFFFFF !important; border: 1px solid #E5E7EB !important; border-top: 3px solid #F06418 !important; border-radius: 16px !important; box-shadow: 0 8px 26px rgba(23, 50, 71, .08) !important; overflow: hidden !important; }",
    ".header { box-sizing: border-box !important; min-height: 48px !important; margin: 0 !important; padding: 12px 16px !important; gap: 10px !important; align-items: center !important; justify-content: space-between !important; background: #173247 !important; border-bottom: 1px solid #26485F !important; }",
    ".header-text { color: #FFFFFF !important; font-size: 14px !important; font-weight: 700 !important; line-height: 1.35 !important; letter-spacing: -.01em !important; }",
    ".rzp-logo, [data-testid=\"footer-section\"] { color: rgba(255, 255, 255, .78) !important; font-size: 11px !important; }",
    ".content { box-sizing: border-box !important; width: 100% !important; padding: 16px !important; gap: 0 !important; background: #FFFFFF !important; }",
    ".content > div { box-sizing: border-box !important; flex: 1 1 0 !important; min-width: 0 !important; }",
    ".content > div + div { margin-left: 16px !important; padding-left: 16px !important; border-left: 1px solid #E9EDF1 !important; }",
    "[data-testid=\"title-section\"] { color: #173247 !important; font-size: 13px !important; font-weight: 650 !important; line-height: 1.4 !important; margin-bottom: 10px !important; }",
    "[data-testid=\"avatar-image\"], [data-testid=\"more-icon\"] { box-sizing: border-box !important; border: 1px solid #E8EDF2 !important; box-shadow: 0 1px 3px rgba(23, 50, 71, .06) !important; }",
    "[data-testid=\"more-icon\"] { color: #526273 !important; font-size: 11px !important; font-weight: 600 !important; }",
    "[data-testid=\"cta-element\"] { box-sizing: border-box !important; min-height: 38px !important; border-radius: 999px !important; font-size: 12px !important; font-weight: 650 !important; line-height: 1.2 !important; letter-spacing: .005em !important; box-shadow: none !important; transition: background-color .18s ease, border-color .18s ease, box-shadow .18s ease, transform .18s ease !important; }",
    "[data-testid=\"cta-element\"].primary-cta { background: #F06418 !important; border: 1px solid #F06418 !important; color: #FFFFFF !important; }",
    "[data-testid=\"cta-element\"].primary-cta:hover { background: #D9550E !important; border-color: #D9550E !important; box-shadow: 0 4px 12px rgba(240, 100, 24, .22) !important; }",
    "[data-testid=\"cta-element\"].secondary-cta { background: #FFFFFF !important; border: 1px solid #D8E0E7 !important; color: #173247 !important; }",
    "[data-testid=\"cta-element\"].secondary-cta:hover { background: #F8FAFC !important; border-color: #AEBCC8 !important; }",
    "[data-testid=\"cta-element\"]:focus-visible { outline: 3px solid rgba(240, 100, 24, .35) !important; outline-offset: 3px !important; }",
    "@media (max-width: 520px) { .header { min-height: 44px !important; padding: 10px 13px !important; } .header-text { font-size: 13px !important; } .content { display: flex !important; flex-direction: column !important; padding: 13px !important; } .content > div { width: 100% !important; flex: 1 1 auto !important; } .content > div + div { margin: 12px 0 0 !important; padding: 12px 0 0 !important; border-left: 0 !important; border-top: 1px solid #E9EDF1 !important; } [data-testid=\"title-section\"] { font-size: 13px !important; margin-bottom: 8px !important; } [data-testid=\"cta-element\"] { min-height: 36px !important; } }",
    "@media (prefers-reduced-motion: reduce) { [data-testid=\"cta-element\"] { transition: none !important; } }"
  ].join("\n");

  let observedShadow = null;
  const customize = () => {
    const component = host.querySelector("main-component");
    const shadow = component && component.shadowRoot;
    if (!shadow) return;

    const themed = shadow.querySelector('[style*="--theme-color"]');
    if (themed) {
      Object.keys(theme).forEach((name) => {
        if (themed.style.getPropertyValue(name).trim() !== theme[name]) {
          themed.style.setProperty(name, theme[name]);
        }
      });
    }

    let style = shadow.querySelector("#b91-razorpay-premium-style");
    if (!style) {
      style = document.createElement("style");
      style.id = "b91-razorpay-premium-style";
      shadow.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;

    if (observedShadow !== shadow) {
      observedShadow = shadow;
      new MutationObserver(customize).observe(shadow, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"]
      });
    }
  };

  new MutationObserver(customize).observe(host, { childList: true, subtree: true });
  customize();
  if (window.customElements) {
    window.customElements.whenDefined("main-component").then(customize);
  }
})();
